module.exports = __webpack_public_path__ + "static/media/logo-freebsd-devil.08a0c13b.svg";